
import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';

interface ExamFormHeaderProps {
  isEditMode: boolean;
  onCancel: () => void;
}

const ExamFormHeader = ({ isEditMode, onCancel }: ExamFormHeaderProps) => {
  return (
    <div className="p-6 border-b">
      <div className="flex items-center gap-4">
        <Button 
          variant="ghost" 
          size="icon" 
          onClick={onCancel}
          className="hover:bg-slate-100"
        >
          <ArrowLeft className="h-5 w-5" />
        </Button>
        <div>
          <h1 className="text-2xl font-bold">
            {isEditMode ? 'Edit Exam Result' : 'Add New Exam Result'}
          </h1>
          <p className="text-muted-foreground">
            {isEditMode ? 'Update the exam details below' : 'Enter the exam details below'}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ExamFormHeader;
